export default "assets/images/icons/property-marker-a59181b2.svg";